<div>
  <div class="flex flex-row justify-between items-center">
    <div class="errorMessage">{{notificationContent.messageKey | translate: notificationContent.placeholders}}</div>
    <button data-cy="close-notification-button" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
